import { useState, useRef, useCallback, useEffect } from 'react';

export default function useHoverEdgeDetection () {
  const [edge, setEdge] = useState({ horizontal: null, vertical: null });
  const ref = useRef(null);
  const throttleTimeout = useRef(null);

  const getEdge = useCallback((event) => {
    if (throttleTimeout.current === null) {
      throttleTimeout.current = setTimeout(() => {
        throttleTimeout.current = null;

        if (!ref.current) return;

        const rect = ref.current.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const horizontal = x < rect.width / 2 ? 'left' : 'right';
        const vertical = y < rect.height / 2 ? 'top' : 'bottom';

        setEdge({ horizontal, vertical });
      }, 100);
    }
  }, []);

  const clearEdge = useCallback(() => {
    setEdge({ horizontal: null, vertical: null });
    if (throttleTimeout.current) {
      clearTimeout(throttleTimeout.current);
      throttleTimeout.current = null;
    }
  }, []);

  const setRef = useCallback((node) => {
    if (node) {
      node.addEventListener('mousemove', getEdge);
      node.addEventListener('mouseleave', clearEdge);
      ref.current = node;
    }
  }, [getEdge, clearEdge]);

  useEffect(() => {
    const currentRef = ref.current;
    return () => {
      if (currentRef) {
        currentRef.removeEventListener('mousemove', getEdge);
        currentRef.removeEventListener('mouseleave', clearEdge);
      }
    };
  }, [getEdge, clearEdge]);

  return [setRef, edge];
}
